export default __webpack_public_path__ + "static/media/valve.913d253d.jpeg";